<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>活动管理/开盘大师</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline label-width="68px" style="margin-left: 6vh">
					<el-form-item style="margin-bottom: 0">
						<el-input v-model="searchForm.nameCn" autocomplete="off" maxlength="30" placeholder="活动标题"
							clearable @input="searchChange" size="small" />
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-select v-model="searchForm.xiaoquId" placeholder="请选择小区" clearable style="width: 100%"
							size="small" filterable @change="searchChange" @clear="searchClearInput">
							<el-option v-for="item in regionArr" :key="item.id" :label="item.xiaoqu_name"
								:value="item.xiaoqu_id" />
						</el-select>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button icon="el-icon-refresh-left" type="warning" @click="clearSearchInput"
							size="small">重置</el-button>
					</el-form-item>
				</el-form>
				<el-button type="success" icon="el-icon-plus" @click="handleNewAdd" size="mini">新增活动</el-button>
			</div>
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini"
			:header-cell-style="{background: '#fff',height: '50px',color: '#909399',fontSize: '16px',fontFamily: 'Arial, sans-serif'}">
			<el-table-column prop="id" label="ID" align="center" />
			<el-table-column prop="name_cn" label="活动标题" align="center" />
			<el-table-column prop="xiaoqus" label="活动小区" align="center">
				<template slot-scope="scope">
					<div>
						{{findXiaoqu(scope.row.xiaoqus)}}
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="public_begin" label="公测开始" align="center" />
			<el-table-column prop="public_test_count" label="公测次数" align="center" />
			<el-table-column prop="" label="正式锁定时间" align="center" width="200">
				<template slot-scope="scope">
					<div v-for="(item,index) in ['开始:' + (scope.row.opening_doings_config_list ? scope.row.opening_doings_config_list.find(item=>item.type=='prod').begin : '') ,'结束:' + (scope.row.opening_doings_config_list ? scope.row.opening_doings_config_list.find(item=>item.type=='prod').end : '') ]"
						:key="index">{{item}}</div>
				</template>
			</el-table-column>
			<el-table-column prop="reserve_count" label="预留数量" align="center" />
			<el-table-column prop="status" label="状态" align="center">
				<template slot-scope="scope">
					<el-switch v-model="scope.row.status" active-value="on" inactive-value="off"
						@change="changeStatus(scope.row)"></el-switch>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="操作" align="center">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handleClick(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
		<el-dialog :title="title" :visible.sync="addOrEditOpen" :close-on-click-modal="false" width="65%"
			class="dialogHeight2 global-dialog-position" :before-close="getout" :lock-scroll="false"
			:append-to-body="true" style="margin-top: -10vh">
			<el-form ref="form" :model="form" label-width="108px" :rules="rules">
				<el-row>
					<el-button type="primary" @click="addTab">+公测</el-button>
					<el-button type="primary" @click="addProdTab">+正式</el-button>
					<el-tabs v-model="tabPick" type="card" closable @tab-remove="removeTab" @tab-click="tabsClick">
						<el-tab-pane label="活动详情" name="main">
							<el-col :span="24">
								<el-form-item label="活动标题" prop="name_cn">
									<el-input v-model="form.name_cn" autocomplete="off" placeholder="请输入" />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="选择小区" prop="xiaoqus">
									<el-select v-model="form.xiaoqus" style="width: 100%;" placeholder="请选择小区"
										clearable size="small" filterable @change="xiaoquSelectChange"
										@clear="addClearInput">
										<el-option v-for="item in regionArr" :key="item.xiaoqu_id"
											:label="item.xiaoqu_name" :value="item.xiaoqu_id" />
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="公测开始时间" prop="public_begin">
									<el-date-picker v-model="form.public_begin" value-format="yyyy-MM-dd HH:mm:ss"
										type="datetime" placeholder="选择日期时间" style="width: 100%" @input="changeDate">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="智能抢位" prop="">
									<el-input v-model="form.reserve_carports" autocomplete="off"
										placeholder="请输入车位id,多个以逗号分隔" />
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="" prop="">
									<el-row>
										<el-col :span="5">
											<div>已选
												{{form.reserve_carports ? form.reserve_carports.split(',').length : 0 }}
												个车位
											</div>
										</el-col>
										<el-col :span="10">
											<el-checkbox label="显示已选车位" border=""
												@change="showSelectCarports"></el-checkbox>
										</el-col>
										<el-col :span="9">
											<el-button type="info" icon="el-icon-upload2" @click="importFile"
												size="small">导入预留车位</el-button>
										</el-col>
									</el-row>
									<el-tabs v-if="carparks.length" type="border-card" v-model="currentTab"
										@tab-click="tabClick">
										<el-tab-pane v-for="(carpark,index) in carparks" :key="carpark.id"
											:label="carpark.title" :name="carpark.id">
											<el-checkbox-group v-if="carpark.carports.length"
												v-model="carpark.selCarportTitles" @change="checkboxChange">
												<el-checkbox
													v-for="(carport,index) in carpark.carports.filter((cpt)=>{ return showSelectedCarports ? carpark.selCarportTitles.includes(cpt.floor+'-'+cpt.title) : true })"
													:key="index" size="mini" border
													:label="carport.floor+'-'+carport.title">
												</el-checkbox>

											</el-checkbox-group>
										</el-tab-pane>
									</el-tabs>
								</el-form-item>
							</el-col>
						</el-tab-pane>
						<el-tab-pane :label="item.name" :name="item.name" v-if="item.type == 'public_test'"
							v-for="(item,index) in form.opening_doings_config_list" :key="index">
							<el-col :span="24">
								<el-form-item label="活动名称" prop="name">
									<el-input v-model="item.name" @input="tabNameChange" placeholder="请输入活动名称"
										:disabled="item.status=='processing' || item.status == 'end'"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="锁定时间" prop="public_lock_time">
									<el-date-picker v-model="item.public_lock_time" value-format="yyyy-MM-dd HH:mm:ss"
										type="datetimerange" align="right" unlink-panels range-separator="至"
										start-placeholder="开始时间" end-placeholder="结束时间" style="width: 100%"
										:disabled="item.status=='processing' || item.status == 'end'"
										@input="publicTestAutoCompute(item)">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="自动销控" prop="">
									<el-switch v-model="item.auto_control" active-value="1" inactive-value="0"
										:disabled="item.status=='processing' || item.status == 'end'"></el-switch><label
										style="margin-left: 20px;">销控顺序：按收藏人数从多到少销控</label>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item v-if="item.auto_control == 1">
									<el-form-item label="计划销控数量" style="height: 60px;">
										<el-input v-model="item.control_plan" @input="inputForceUpdate"
											@blur="publicTestAutoCompute(item)" placeholder="请输入数字，销控目标是被3人以上收藏的车位"
											:disabled="item.status=='processing' || item.status == 'end'"></el-input>
									</el-form-item>
									<el-form-item label="第1秒销控数量" style="height: 60px;">
										<el-input v-model="item.control_on_begin" @input="inputForceUpdate"
											@blur="publicTestAutoCompute(item)" placeholder="请输入数字，建议总数量的一半"
											:disabled="item.status=='processing' || item.status == 'end'"></el-input>
									</el-form-item>
									<el-form-item label="持续销控节奏" style="height: 60px;">
										<label>第</label><el-input v-model="item.control_start_first_gap"
											@input="inputForceUpdate" @blur="publicTestAutoCompute(item)"
											style="width: 100px;margin-left: 10px;margin-right: 10px;"
											placeholder="请输入数字"
											:disabled="item.status=='processing' || item.status == 'end'"></el-input><label>秒开始，每</label><el-input
											v-model="item.auto_control_gap" @input="inputForceUpdate"
											@blur="publicTestAutoCompute(item)"
											style="width: 100px;margin-left: 10px;margin-right: 10px;"
											placeholder="请输入数字"
											:disabled="item.status=='processing' || item.status == 'end'"></el-input><label>分钟销控</label><el-input
											v-model="item.auto_control_count_unit" disabled
											style="width: 100px;margin-left: 10px;margin-right: 10px;"
											placeholder="请输入数字"></el-input><label>个。</label>
									</el-form-item>
								</el-form-item>
							</el-col>
						</el-tab-pane>
						<el-tab-pane :label="item.name" :name="item.name" v-if="item.type == 'prod'"
							v-for="(item,index) in form.opening_doings_config_list" :key="index">
							<el-col :span="24">
								<el-form-item label="活动名称" prop="name">
									<el-input v-model="item.name" @input="tabNameChange" placeholder="请输入活动名称"
										:disabled="item.status=='processing' || item.status == 'end'"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="锁定时间" prop="prod_lock_time">
									<el-date-picker v-model="item.prod_lock_time" value-format="yyyy-MM-dd HH:mm:ss"
										type="datetimerange" align="right" unlink-panels range-separator="至"
										start-placeholder="开始时间" end-placeholder="结束时间" style="width: 100%"
										:disabled="item.status=='processing' || item.status == 'end'"
										@input="prodAutoCompute(item)">
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="自动销控" prop="">
									<el-switch v-model="item.auto_control" active-value="1" inactive-value="0"
										:disabled="item.status=='processing' || item.status == 'end'"></el-switch><label
										style="margin-left: 20px;">销控目标：未被收藏的车位</label>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item v-if="item.auto_control == 1">
									<el-form-item label="计划销控数量" style="height: 60px;">
										<el-input v-model="item.control_plan" disabled
											placeholder="销控顺序：每个楼层按比例同时销控"></el-input>
									</el-form-item>
									<el-form-item v-if="item.carpark_floor_control_dto">
										<el-form-item style="margin-left: 118px;"
											v-for="(sitem,sindex) in item.carpark_floor_control_dto.control_dto_list"
											:key="sindex">
											<el-row>
												<span>{{sitem.carpark_name}}</span>
											</el-row>
											<el-row style="height: 50px;"
												v-for="(ssitem, ssindex) in sitem.floor_control_dtos" :key="ssindex">
												<span>{{ssitem.floor_name}}</span><el-input v-model="ssitem.control_num"
													@input="inputForceUpdate" @blur="prodAutoCompute(item)"
													style="width: 100px; margin-left: 10px;margin-right: 10px;"
													placeholder="请输入数字"
													:disabled="item.status=='processing' || item.status == 'end'"></el-input><span>个</span>
											</el-row>
										</el-form-item>
									</el-form-item>
									<el-form-item label="持续销控节奏" style="margin-top: 20px;">
										<label>第</label><el-input v-model="item.control_start_first_gap"
											@input="inputForceUpdate" @blur="prodAutoCompute(item)"
											style="width: 100px;margin-left: 10px;margin-right: 10px;"
											placeholder="请输入数字"
											:disabled="item.status=='processing' || item.status == 'end'"></el-input><label>分钟开始，每</label><el-input
											v-model="item.auto_control_gap" @input="inputForceUpdate"
											@blur="prodAutoCompute(item)"
											style="width: 100px;margin-left: 10px;margin-right: 10px;"
											placeholder="请输入数字"
											:disabled="item.status=='processing' || item.status == 'end'"></el-input><label>分钟销控</label><el-input
											v-model="item.auto_control_count_unit" disabled
											style="width: 100px;margin-left: 10px;margin-right: 10px;"
											placeholder="请输入数字"></el-input><label>个。</label>
									</el-form-item>
								</el-form-item>
							</el-col>
						</el-tab-pane>
					</el-tabs>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>

		<!-- 导入车位图弹窗 -->
		<el-dialog title="导入预留车位" :visible.sync="importOpen" :close-on-click-modal="false" width="40%"
			class="global-dialog-position" :before-close="getouts" style="margin-top: -10vh">
			<el-select v-model="carparkId" style="width: 100%;" placeholder="请选择车库" clearable size="small" filterable
				@change="carparksChange" @clear="clearInput1">
				<el-option v-for="item in carparks" :key="item.id" :label="item.title" :value="item.id" />
			</el-select>
			<el-select v-model="floorId" style="width: 100%;" placeholder="请选择楼层" clearable size="small" filterable
				@change="floorsChange" @clear="clearInput2">
				<el-option v-for="item in floorArr" :key="item.id" :label="item.title" :value="item.id" />
			</el-select>
			<el-upload class="upload-container" style="width: 100%;" ref="upload" v-loading="diaIf"
				element-loading-text="上传中..." drag :show-file-list="true" :auto-upload="false" :action="uploadCheWeiUrl"
				:data="{floor_id:floorId}" :on-success="handleSuccess" :on-error="handleError" :headers="headers">
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">
					将文件拖到此处，或<em>点击上传</em>
				</div>
			</el-upload>
			<el-button style="width: 100%; height: 60px;" size="small" type="success"
				@click="submitUpload">上传到服务器</el-button>
		</el-dialog>
	</div>
</template>

<script>
	import tableCommon from "../../../mixins/table-common";
	import {
		getActiveFreeParkingList,
		addActiveFreeParking,
		editActiveFreeParking,
		changeActiveStatus
	} from "../../api/freeParking";
	import {
		getcarList
	} from "../../api/garage";
	import {
		getCookie
	} from "../../utils/util";
	import {
		getFloorList
	} from "../../api/floor";
	import {
		getCarList
	} from "../../api/parking";

	export default {
		mixins: [tableCommon],
		data() {
			return {
				// 请求地址api
				api: {
					list: getActiveFreeParkingList,
					add: addActiveFreeParking,
					edit: editActiveFreeParking,
				},
				// 规则验证
				rules: {
					name_cn: [{
						required: true,
						message: "请输入标题",
						trigger: "blur"
					}],

					xiaoqus: [{
						required: true,
						message: "请选择小区",
						trigger: "change"
					}],
					public_begin: [{
						required: true,
						message: "请选择公测时间",
						trigger: "blur"
					}],
					'opening_doings_config_list.name': [{
						required: true,
						message: "请输入活动名称",
						trigger: "blur"
					}],
					'opening_doings_config_list.public_lock_time': [{
						required: true,
						message: "请选择公测锁定时间",
						trigger: "blur"
					}],
					'opening_doings_config_list.prod_lock_time': [{
						required: true,
						message: "请选择正式锁定时间",
						trigger: "blur"
					}]
				},
				// 传参
				form: {},
				// 弹窗标题
				title: "新增",
				addOrEditOpen: false,
				// 查询参数
				searchForm: {
					page: 1,
					pageSize: 15,
					nameCn: '',
					xiaoquId: ''
				},
				tableData: [],
				regionArr: [],
				carparks: [],
				currentTab: '',
				showSelectedCarports: false,
				floorArr: [],
				importOpen: false,
				carparkId: '',
				floorId: '',
				diaIf: false,
				// 上传头文件
				headers: {
					Authorization: "Bearer " + getCookie("logintoken"),
				},
				uploadCheWeiUrl: process.env.VUE_APP_URL + "/admin/doingsInfo/reserveCarportsImport",
				tabName: null,
				tabPick: 'main',
				initLoad: false,
			};
		},
		mounted() {
			const form = {
				select: 1,
			};
			getcarList(form).then((res) => {
				this.regionArr = res.data.records.filter((item, index, self) => {
					return self.findIndex((t) => t.xiaoqu_id === item.xiaoqu_id) === index;
				});
				this.regionArr.forEach((item, index) => item.xiaoqu_id = item.xiaoqu_id.toString());
				this.initList();
			});
		},
		methods: {
			// 选项卡点击事件
			tabsClick(res) {
				// 将绑定name取出
				this.tabPick = res._props.name;
			},
			// 增加选项卡
			addTab() {
				let len = this.form.opening_doings_config_list.length;
				if (len >= 2) {
					let name = '公测_' + (len - 1);
					this.form.opening_doings_config_list.splice(len - 1, 0, {
						name: name,
						type: 'public_test',
						auto_control: '1',
						public_lock_time: []
					});
					this.tabPick = name;
				}
			},
			// 增加正式选项卡
			addProdTab() {
				let prodCount = this.form.opening_doings_config_list.filter(item => item.type == 'prod').length;
				let name = '正式_' + (prodCount + 1);
				this.form.opening_doings_config_list.push({
					name: name,
					type: 'prod',
					auto_control: '1',
					prod_lock_time: []
				});
				this.tabPick = name;
			},
			// 移除选项卡
			removeTab(tabName) {
				if (tabName !== "main") {
					let obj = this.form.opening_doings_config_list.find(item => item.name == tabName);
					if (!obj) return;
					if (tabName === "正式") {
						return;
					}
					if (obj.type == 'public_test') {
						let publicTests = this.form.opening_doings_config_list.filter(item => item.type == 'public_test');
						if (publicTests.length == 1) return;
					}
					if (obj.status == 'processing') {
						this.$message.warning(tabName + '在运行中，不能删除');
						return;
					}
					if (obj.status == 'end') {
						this.$message.warning(tabName + '已结束，不能删除');
						return;
					}
					this.$confirm("确定删除吗？", "删除", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}).then(async () => {
						let index = this.form.opening_doings_config_list.findIndex(item => item.name == tabName);
						this.form.opening_doings_config_list.splice(index, 1);
						this.tabPick = this.form.opening_doings_config_list[0].name;
						this.$forceUpdate();
					});
				}
			},
			tabNameChange(value) {
				let objs = this.form.opening_doings_config_list.filter(item => item.name == value);
				if (objs.length > 1) {
					this.$message.warning('活动名称重复，请修改');
					return;
				}
				this.tabPick = value;
			},
			// 导入预留车位
			importFile() {
				this.importOpen = true;
			},
			carparksChange(e) {
				this.carparkId = e;
				this.getFloorLists(e, (res) => {

				});
			},
			clearInput1() {
				this.carparkId = '';
				this.floorId = '';
			},
			floorsChange(e) {
				this.floorId = e;
			},
			clearInput2() {
				this.floorId = '';
			},
			getouts() {
				this.importOpen = false;
			},
			submitUpload() {
				if (this.floorId === '') {
					this.$message.warning("请选择车位楼层");
				} else {
					this.$refs.upload.submit();
				}
			},
			handleSuccess(res, file, fileList) {
				// 处理上传成功的逻辑，可以在这里更新文件状态等  
				console.log('上传结果：', res)
				if (res.code == 200) {
					this.form.reserve_carports = res.data;
					this.importOpen = false;
					if (this.form.xiaoqus) {
						this.getCarparks(this.form.xiaoqus);
					}
				} else {
					this.$message.error('上传失败');
				}
			},
			handleError(err, file, fileList) {
				// 处理上传失败的逻辑，可以在这里更新文件状态等  
				console.log('handleError')
				this.$message.error('上传失败')
			},
			// 楼层
			getFloorLists(carpark_id, callback) {
				const floorForm = {
					carpark_id: carpark_id,
				};
				getFloorList(floorForm).then((res) => {
					if (callback) {
						callback(res.data.records);
					}
					this.floorArr = res.data.records;
				});
			},
			showSelectCarports(e) {
				this.showSelectedCarports = e;
				this.$forceUpdate();
			},
			xiaoquSelectChange(data) {
				this.$forceUpdate();
				this.getCarparks(data);
			},
			tabClick(tab, event) {
				const carpark = this.carparks[tab.index];
				this.currentTab = carpark.id;
			},
			checkboxChange() {
				var selectedCarportIds = [];
				this.carparks.forEach((carpark) => {
					carpark.carports.forEach((carport) => {
						console.log('=====:', carport, this.floorArr)
						if (carpark.selCarportTitles.includes(carport.floor + '-' + carport.title)) {
							selectedCarportIds.push(carport.id);
						}
					});

				});

				this.form.reserve_carports = selectedCarportIds.length ? selectedCarportIds.join(',') : '';
			},
			getCarparks(xiaoqu_id) {
				getcarList({
					page: 1,
					pageSize: 15,
					xiaoqu_id: xiaoqu_id
				}).then((res) => {
					if (res.code == 200) {
						let carparks = [];
						res.data.records.forEach((item) => {
							const carpark = {};
							carpark.id = item.id.toString();
							carpark.title = item.title;
							carpark.carports = [];
							carpark.selCarportTitles = [];
							carparks.push(carpark);
						});

						this.currentTab = carparks.length ? carparks[0].id : '';
						carparks.forEach((item) => {
							this.getCarpots(item);
						});

						this.carparks = carparks;
					}
				});
			},
			groupBy(arr, key) {
				return arr.reduce((acc, obj) => {
					const groupKey = obj[key];
					if (!acc[groupKey]) acc[groupKey] = [];
					acc[groupKey].push(obj);
					return acc;
				}, {});
			},
			sortGroupedData(groupedData, sortKey, isAsc = true) {
				const sortedKeys = Object.keys(groupedData).sort((a, b) =>
					isAsc ? a[sortKey] - b[sortKey] : b[sortKey] - a[sortKey]
				);
				return sortedKeys.reduce((acc, key) => {
					acc[key] = groupedData[key];
					return acc;
				}, {});
			},
			getCarpots(carpark) {
				if (carpark.carports.length) return;
				getCarList({
					page: 1,
					pageSize: 5000,
					carpark_id: carpark.id
				}).then((res) => {
					if (res.code == 200) {
						this.getFloorLists(carpark.id, (floorArr) => {

							carpark.floors = floorArr;

							var carports_o = res.data.records;
							var carports_g = this.groupBy(carports_o, 'floor_id');
							var carports_f = [];
							Object.keys(carports_g).forEach(key => {
								carports_g[key].forEach(i => {
									carports_f.push(i);
								})
							});

							carports_f.forEach((item, index) => {
								if (item.carport_status == 1) {
									var rcarportsIds = [];
									if (this.form.reserve_carports && this.form.reserve_carports
										.length) {
										rcarportsIds = this.form.reserve_carports.split(',');
									}
									let sel = rcarportsIds.includes(item.id.toString());
									const carport = {
										id: item.id.toString(),
										title: item.carport_title,
										floor: floorArr.find((i) => i.id == item.floor_id)
											.title
									};
									if (sel) {
										carpark.selCarportTitles.push(carport.floor + '-' + carport
											.title);
									}
									carpark.carports.push(carport);
								}
							});

							if (this.form.opening_doings_config_list) {
								// 给所有 prod 类型的配置项初始化地库数据
								let prodList = this.form.opening_doings_config_list.filter(item => item.type == 'prod');
								prodList.forEach(prod => {
									if (!prod.carpark_floor_control_dto) {
										prod.carpark_floor_control_dto = {
											control_dto_list: []
										};
									}
									
									let carparkObj = prod.carpark_floor_control_dto.control_dto_list.find(item => item.carpark_id == carpark.id);
									if (!carparkObj) {
										carparkObj = {
											carpark_id: carpark.id,
											carpark_name: carpark.title,
											floor_control_dtos: []
										};
										carpark.floors.forEach(sitem => {
											let floor = {
												floor_id: sitem.id,
												floor_name: sitem.title,
												control_num: 0
											}
											let floorObj = carparkObj.floor_control_dtos.find(item => item.floor_id == sitem.id);
											if (!floorObj) {
												carparkObj.floor_control_dtos.push(floor);
											}
										})
										prod.carpark_floor_control_dto.control_dto_list.push(carparkObj);
									}
								});
							}
							
							this.$forceUpdate();
						});

					}
				});
			},
			searchClearInput() {
				this.searchForm.xiaoquId = ''
				this.searchChange();
			},
			clearSearchInput() {
				this.searchForm.nameCn = '';
				this.searchForm.xiaoquId = '';
				this.searchChange();
			},
			addClearInput() {
				this.form.xiaoqus = null;
			},
			changeDate(e) {
				this.$forceUpdate();
			},
			findXiaoqu(xiaoqu_id) {
				let xiaoqu = this.regionArr ? this.regionArr.find(item => item.xiaoqu_id == xiaoqu_id) : null;
				return xiaoqu ? xiaoqu.xiaoqu_name : '';
			},
			// 重置
			reset() {
				this.form = {};
			},
			// 新增弹窗
			handleNewAdd() {
				this.title = "新增";
				this.reset();
				this.form.opening_doings_config_list = [{
					name: '公测',
					type: 'public_test',
					auto_control: '1',
					public_lock_time: []
				}, {
					name: '正式',
					type: 'prod',
					auto_control: '1',
					prod_lock_time: []
				}];

				this.handleAdd();
				this.$nextTick(() => {
					this.$refs.form.clearValidate();
				});
			},
			// 修改弹窗
			handleClick(row) {
				this.title = "修改";
				this.form = JSON.parse(JSON.stringify(row));
				console.log('行修改点击：', this.form);
				if (this.form.xiaoqus) {
					this.getCarparks(this.form.xiaoqus);
				}
				if (this.form.opening_doings_config_list) {
					this.form.opening_doings_config_list.forEach(item => {
						if (item.type == 'public_test') {
							if (item.begin && item.end) {
								item.public_lock_time = [item.begin, item.end];
							} else {
								item.public_lock_time = [];
							}
						}
						item.auto_control = item.auto_control.toString();
						if (item.type == 'prod') {
							if (item.begin && item.end) {
								item.prod_lock_time = [item.begin, item.end];
							} else {
								item.prod_lock_time = [];
							}
						}
					});
				}

				this.handleEdit();
			},
			publicTestInput(item) {
				if (!item.public_lock_time || item.public_lock_time.length == 0) {
					this.$message.warning(item.name + ':请选择锁定时间范围');
					return false;
				}
				if (!item.control_plan || item.control_plan.length == 0 || item.control_plan == 0) {
					this.$message.warning(item.name + ':请输入计划销控数量');
					return false;
				}
				if (!item.control_on_begin || item.control_on_begin.length == 0 || item.control_on_begin == 0) {
					this.$message.warning(item.name + ':请输入第1秒销控数量');
					return false;
				}
				if (!item.control_start_first_gap || item.control_start_first_gap.length == 0 || item
					.control_start_first_gap == 0) {
					this.$message.warning(item.name + ':请输入第几秒开始销控');
					return false;
				}
				if (!item.auto_control_gap || item.auto_control_gap.length == 0 || item.auto_control_gap == 0) {
					this.$message.warning(item.name + ':请输入每几分钟销控');
					return false;
				}
				return true;
			},
			inputForceUpdate() {
				this.$forceUpdate();
			},
			publicTestAutoCompute(item) {
				this.$forceUpdate();
				if (!item.public_lock_time || item.public_lock_time.length == 0) {
					return;
				}
				if (!item.control_plan || item.control_plan.length == 0 || item.control_plan == 0) {
					return;
				}
				if (!item.control_on_begin || item.control_on_begin.length == 0 || item.control_on_begin == 0) {
					return;
				}
				if (!item.control_start_first_gap || item.control_start_first_gap.length == 0 || item
					.control_start_first_gap == 0) {
					return;
				}
				if (!item.auto_control_gap || item.auto_control_gap.length == 0 || item.auto_control_gap == 0) {
					return;
				}

				let beginTime = new Date(item.public_lock_time[0]).getTime();
				let endTime = new Date(item.public_lock_time[1]).getTime();
				let temp = (endTime - beginTime) / 1000;
				item.auto_control_count_unit = Math.ceil((item.control_plan - item.control_on_begin) / ((temp - item
					.control_start_first_gap) / (item.auto_control_gap * 60)));

				this.$forceUpdate();
			},
			prodInput(item) {
				if (!item.prod_lock_time || item.prod_lock_time.length == 0) {
					this.$message.warning(item.name + ':请选择锁定时间范围');
					return false;
				}
				let xkCount = 0;
				item.carpark_floor_control_dto.control_dto_list.forEach(i => {
					i.floor_control_dtos.forEach(ii => {
						xkCount += parseInt(ii.control_num);
					});
				});
				if (xkCount == 0) {
					this.$message.warning(item.name + ':请输入楼层计划销控数量');
					return false;
				}
				if (!item.control_start_first_gap || item.control_start_first_gap.length == 0 || item
					.control_start_first_gap == 0) {
					this.$message.warning(item.name + ':请输入第几分钟开始销控');
					return false;
				}

				if (!item.auto_control_gap || item.auto_control_gap.length == 0 || item.auto_control_gap == 0) {
					this.$message.warning(item.name + ':请输入每几分钟销控');
					return false;
				}
				return true;
			},
			prodAutoCompute(item) {
				this.$forceUpdate();
				if (!item.prod_lock_time || item.prod_lock_time.length == 0) {
					return;
				}
				let xkCount = 0;
				item.carpark_floor_control_dto.control_dto_list.forEach(i => {
					i.floor_control_dtos.forEach(ii => {
						xkCount += parseInt(ii.control_num);
					});
				});
				if (xkCount == 0) {
					return;
				}
				if (!item.control_start_first_gap || item.control_start_first_gap.length == 0 || item
					.control_start_first_gap == 0) {
					return;
				}

				if (!item.auto_control_gap || item.auto_control_gap.length == 0 || item.auto_control_gap == 0) {
					return;
				}

				let beginTime = new Date(item.prod_lock_time[0]).getTime();
				let endTime = new Date(item.prod_lock_time[1]).getTime();
				let temp = (endTime - beginTime) / 1000;
				let cm = (temp - item.control_start_first_gap * 60) / (item.auto_control_gap * 60);
				item.auto_control_count_unit = Math.ceil(xkCount / cm);

				this.$forceUpdate();

			},
			// 状态修改
			changeStatus(res) {
				this.form = JSON.parse(JSON.stringify(res));
				this.actionType = "edit";
				changeActiveStatus(this.form.id).then((msg) => {
					if (msg.code !== 200) return this.$message("获取状态失败");
					this.$message.success("修改成功");
					this.searchChange();
				});
			},
			// 点击确定
			submitForms() {
				let canSubmit = true;
				
				// 校验活动名称是否重复
				let nameList = this.form.opening_doings_config_list.map(item => item.name);
				let duplicateNames = nameList.filter((name, index) => nameList.indexOf(name) !== index);
				if (duplicateNames.length > 0) {
					this.$message.warning('活动名称不能重复，请修改！');
					return;
				}
				
				this.form.opening_doings_config_list.forEach(item => {
					if (item.type == 'public_test' && item.auto_control == '1') {
						canSubmit = this.publicTestInput(item);
					}
					if (item.type == 'prod' && item.auto_control == '1') {
						canSubmit = this.prodInput(item);
					}
					if (item.type == 'public_test' && item.public_lock_time.length == 2) {
						item.begin = item.public_lock_time[0];
						item.end = item.public_lock_time[1];
					}

					if (item.type == 'prod' && item.prod_lock_time.length == 2) {
						item.begin = item.prod_lock_time[0];
						item.end = item.prod_lock_time[1];
					}
				});

				if (!canSubmit) {
					this.$message.warning('请完善活动数据后再提交！');
					return;
				}

				try {
					// 提交表单
					this.submitForm(this.form);
				} catch (error) {
					// 处理提交失败的情况
					console.error("提交失败:", error);
					// 执行适当的操作，例如显示错误提示信息或进行其他处理
				}
			},
			// 关闭复制弹窗
			copyout() {
				this.copyIf = false;
				this.$refs.copyForm.clearValidate();
			},
			// 关闭弹窗
			getout() {
				this.addOrEditOpen = false;
				this.tabPick = 'main';
				this.$refs.form.clearValidate();
			},
		},
	};
</script>
<style scoped>
	/deep/.dialogHeight2 .el-dialog__body {
		overflow-y: auto;
	}

	/deep/.dialogHeight .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.dialogHeightX .el-dialog__body {
		height: 100%;
		overflow: hidden;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.upload-container {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.uploadSty .el-upload--picture-card {
		width: 110px;
		height: 110px;
		line-height: 110px;
	}

	/deep/.disUploadSty .el-upload--picture-card {
		display: none;
		/* 上传按钮隐藏 */
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.avatar-wrapper {
		position: relative;
	}

	.el-icon-close {
		position: absolute;
		top: 0;
		right: 6vh;
		cursor: pointer;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	/deep/ .el-dialog__body {
		height: 60vh;
	}
</style>


// WEBPACK FOOTER //
// src/views/active/freeParking.vue